module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Ga-Ha-Ia-Gb.7b7a22d7.png";